import PropTypes from 'prop-types';
import { headingPropTypes } from '@Theme/natucare/modules/Footer/components/Heading/HeadingPropTypes';
export const newsletterFormPropTypes = {
  heading: headingPropTypes.heading,
  subheading: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  consent: PropTypes.string,
  variant: PropTypes.oneOf(['Footer', 'FeatureContent', 'V4Footer']),
  onSubscribe: PropTypes.func.isRequired,
  subscriptionStatus: PropTypes.shape({
    isSending: PropTypes.bool,
    isSubscribed: PropTypes.bool,
    isEmailTaken: PropTypes.bool
  }).isRequired
};